<!--
 * @Date: 2022-01-12 11:26:56
 * @Description: 批阅 帮助
-->

<template>
  <div>
    <img
      class="portrait"
      src="@/assets/img/helperinfo-portrait.png"
      style="width: 100%;"
      alt=""
    />
    <img
      class="landscape"
      src="@/assets/img/helperInfo.png"
      style="width: 100%;"
      alt=""
    />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
img {
  display: none;
}
// 竖屏
@media screen and (orientation: portrait) {
  .portrait {
    display: block;
  }
}
// 横屏
@media screen and (orientation: landscape) {
  .landscape {
    display: block;
  }
}
</style>
